import { FC, useEffect, useRef, useState } from "react";
import { I_city, I_hub, I_tab, I_tabsDic, I_type, I_typesDic } from "./types";
import Header from "./header";
import { FreelancerProvider, RootFreelancerProvider, useRootFreelancerProvider } from "./context";
import usePopup, { I_usePopup } from "./../../components/aio/aio-popup";
import AddForm from "./add-form";
import Apis from "./apis";
import { Table } from "./table";
import { useGrid } from "./grid-filter-hook";
import AIODate from "./../../components/aio/aio-date";
import { Helmet } from "react-helmet";
import { useRoles } from "./use-roles";
//@ts-ignore
import './style.css';
//@ts-ignore
import './index.css';
//http://192.168.78.243:8090/swagger-ui/index.html#/public-api/commonObjects
//http://192.168.78.243:20000/swagger-ui/index.html#/employee-api/create_2
const BoxitFreelancer: FC<{ token: string }> = ({ token }) => {
    const base_url = process.env.REACT_APP_BASE_URL
    const currenthub: I_hub = {
        "id": 2,
        "text": "هاب تهران",
    }
    const tabsDic: I_tabsDic = {
        'userInfo': { employeeTypes: [0, 1, 2, 4], text: 'اطلاعات فردی' },
        'carInfo': { employeeTypes: [0, 2, 4], text: 'اطلاعات خودرو' },
        'cities': { employeeTypes: [1], text: 'شهر های منتسب' },
        'images': { employeeTypes: [0, 2, 4], text: 'تصویر مدارک' },
    }
    
    const typesDic: I_typesDic = {
        '0': { value:0,text: 'راننده فریلنسر', tabs: ['userInfo', 'carInfo', 'images'] },
        '1': { value:1,text: 'اصلاح کننده آدرس', tabs: ['userInfo', 'cities'] },
        '2': { value:2,text: 'پرسنل تمام وقت', tabs: ['userInfo', 'images'] },
        '4': { value:4,text: 'راننده تمام وقت', tabs: ['userInfo', 'carInfo', 'images'] },
        '6': { value:6,text: 'اپراتور', tabs: ['userInfo', 'images'] },
    }
    const apisRef = useRef<Apis>(new Apis({ base_url, token,typesDic }))
    const apis = apisRef.current
    const popup = usePopup()
    const [options, setOptions] = useState<any>({})
    const [cities, setCities] = useState<I_city[]>([])
    const fetchOptions = async () => {
        const res = await apis.enums()
        if (res) { setOptions(res) }
    }
    const fetchCities = async () => {
        const res = await apis.cities()
        if (res) { setCities(res) }
    }
    useEffect(() => {
        fetchOptions();
        fetchCities()
    }, [])
    if (!options) { return null }
    return (
        <RootFreelancerProvider value={{cities,options,popup,apis,currenthub}}>
            <App typesDic={typesDic} tabsDic={tabsDic}/>
        </RootFreelancerProvider>
    )
}
export default BoxitFreelancer
const App: FC<{typesDic:I_typesDic,tabsDic:I_tabsDic}> = ({typesDic,tabsDic}) => {
    const { apis, currenthub,popup } = useRootFreelancerProvider();
    const gridHook = useGrid({ currenthub, apis })
    const rolesHook = useRoles();
    const openAddModal = () => {
        popup.addModal({
            header: { title: 'افزودن پرسنل خارج از سازمان' },
            body: <AddForm />,
            headerAttrs: { className: 'freelancer-modal-header' }
        })
    }
    const openEditModal = async (id: number) => {
        popup.addModal({ header: { title: 'ویرایش راننده' }, body: (<AddForm id={id} />) })
    }
    
    const typeOptions:{text:string,value:I_type}[] = Object.keys(typesDic).map((key)=>{
        return {text:typesDic[key].text,value:+key} as {text:string,value:I_type}
    })
    const inputCls = 'border !border-[#ababab] !rounded-lg'
    return (
        <FreelancerProvider value={{
            gridHook, openAddModal, openEditModal,
            tabsDic, typesDic,typeOptions,rolesHook,inputCls
        }}>
            <div className="freelancer-grid text-xs" style={{ direction: 'rtl' }}>
                <div className="h-[48px] flex flex-row items-center px-2">
                    مدیریت پرسنل / پرسنل خارج از سازمان
                    <Helmet><title>مدیریت پرسنل / پرسنل خارج از سازمان</title></Helmet>
                </div>
                <Header />
                <div className="h-[12px]"></div>
                <Table />
                {popup.render()}
            </div>
        </FreelancerProvider>
    )
}